/**
 * Specifies pivot external events
 *
 * @hidden
 */
/** @hidden */
export var load = 'load';
/** @hidden */
export var enginePopulating = 'enginePopulating';
/** @hidden */
export var enginePopulated = 'enginePopulated';
/** @hidden */
export var onFieldDropped = 'onFieldDropped';
/** @hidden */
export var fieldDrop = 'fieldDrop';
/** @hidden */
export var beforePivotTableRender = 'beforePivotTableRender';
/** @hidden */
export var afterPivotTableRender = 'afterPivotTableRender';
/** @hidden */
export var beforeExport = 'beforeExport';
/** @hidden */
export var exportComplete = 'exportComplete';
/** @hidden */
export var excelHeaderQueryCellInfo = 'excelHeaderQueryCellInfo';
/** @hidden */
export var pdfHeaderQueryCellInfo = 'pdfHeaderQueryCellInfo';
/** @hidden */
export var excelQueryCellInfo = 'excelQueryCellInfo';
/** @hidden */
export var pdfQueryCellInfo = 'pdfQueryCellInfo';
/** @hidden */
export var onPdfCellRender = 'onPdfCellRender';
/** @hidden */
export var dataBound = 'dataBound';
/** @hidden */
export var queryCellInfo = 'queryCellInfo';
/** @hidden */
export var headerCellInfo = 'headerCellInfo';
/** @hidden */
export var hyperlinkCellClick = 'hyperlinkCellClick';
/** @hidden */
export var resizing = 'resizing';
/** @hidden */
export var resizeStop = 'resizeStop';
/** @hidden */
export var cellClick = 'cellClick';
/** @hidden */
export var drillThrough = 'drillThrough';
/** @hidden */
export var beforeColumnsRender = 'beforeColumnsRender';
/** @hidden */
export var selected = 'selected';
/** @hidden */
export var selecting = 'selecting';
/** @hidden */
export var cellSelecting = 'cellSelecting';
/** @hidden */
export var drill = 'drill';
/** @hidden */
export var cellSelected = 'cellSelected';
/** @hidden */
export var cellDeselected = 'cellDeselected';
/** @hidden */
export var rowSelected = 'rowSelected';
/** @hidden */
export var rowDeselected = 'rowDeselected';
/** @hidden */
export var beginDrillThrough = 'beginDrillThrough';
/** @hidden */
export var editCompleted = 'editCompleted';
/** @hidden */
export var multiLevelLabelClick = 'multiLevelLabelClick';
/** @hidden */
export var saveReport = 'saveReport';
/** @hidden */
export var fetchReport = 'fetchReport';
/** @hidden */
export var loadReport = 'loadReport';
/** @hidden */
export var renameReport = 'renameReport';
/** @hidden */
export var removeReport = 'removeReport';
/** @hidden */
export var newReport = 'newReport';
/** @hidden */
export var toolbarRender = 'toolbarRender';
/** @hidden */
export var toolbarClick = 'toolbarClick';
/** @hidden */
export var chartTooltipRender = 'chartTooltipRender';
/** @hidden */
export var chartLegendClick = 'chartLegendClick';
/** @hidden */
export var chartLoaded = 'chartLoaded';
/** @hidden */
export var multiLevelLabelRender = 'multiLevelLabelRender';
/** @hidden */
export var beforePrint = 'beforePrint';
/** @hidden */
export var animationComplete = 'animationComplete';
/** @hidden */
export var legendRender = 'legendRender';
/** @hidden */
export var textRender = 'textRender';
/** @hidden */
export var pointRender = 'pointRender';
/** @hidden */
export var seriesRender = 'seriesRender';
/** @hidden */
export var chartMouseMove = 'chartMouseMove';
/** @hidden */
export var chartMouseClick = 'chartMouseClick';
/** @hidden */
export var pointMove = 'pointMove';
/** @hidden */
export var chartMouseLeave = 'chartMouseLeave';
/** @hidden */
export var chartMouseDown = 'chartMouseDown';
/** @hidden */
export var chartMouseUp = 'chartMouseUp';
/** @hidden */
export var dragComplete = 'dragComplete';
/** @hidden */
export var zoomComplete = 'zoomComplete';
/** @hidden */
export var scrollStart = 'scrollStart';
/** @hidden */
export var scrollEnd = 'scrollEnd';
/** @hidden */
export var scrollChanged = 'scrollChanged';
/** @hidden */
export var chartLoad = 'chartLoad';
/** @hidden */
export var chartResized = 'chartResized';
/** @hidden */
export var chartAxisLabelRender = 'chartAxisLabelRender';
/** @hidden */
export var chartSeriesCreated = 'chartSeriesCreated';
/** @hidden */
export var aggregateCellInfo = 'aggregateCellInfo';
/** @hidden */
export var onHeadersSort = 'onHeadersSort';
/** @hidden */
export var contextMenuClick = 'contextMenuClick';
/** @hidden */
export var contextMenuOpen = 'contextMenuOpen';
/** @hidden */
export var fieldListRefreshed = 'fieldListRefreshed';
/** @hidden */
export var conditionalFormatting = 'conditionalFormatting';
/** @hidden */
export var beforePdfExport = 'beforePdfExport';
/** @hidden */
export var beforeExcelExport = 'beforeExcelExport';
/** @hidden */
export var memberFiltering = 'memberFiltering';
/** @hidden */
export var calculatedFieldCreate = 'calculatedFieldCreate';
/** @hidden */
export var memberEditorOpen = 'memberEditorOpen';
/** @hidden */
export var fieldRemove = 'fieldRemove';
/** @hidden */
export var numberFormatting = 'numberFormatting';
/** @hidden */
export var aggregateMenuOpen = 'aggregateMenuOpen';
/** @hidden */
export var fieldDragStart = 'fieldDragStart';
/** @hidden */
export var chartPointClick = 'chartPointClick';
/** @hidden */
export var beforeServiceInvoke = 'beforeServiceInvoke';
/** @hidden */
export var afterServiceInvoke = 'afterServiceInvoke';
/** @hidden */
export var actionBegin = 'actionBegin';
/** @hidden */
export var actionComplete = 'actionComplete';
/** @hidden */
export var actionFailure = 'actionFailure';
/**
 * Specifies pivot internal events
 */
/** @hidden */
export var initialLoad = 'initial-load';
/** @hidden */
export var uiUpdate = 'ui-update';
/** @hidden */
export var scroll = 'scroll';
/** @hidden */
export var verticalScroll = 'vertical-scroll';
/** @hidden */
export var horizontalScroll = 'horizontal-scroll';
/** @hidden */
export var contentReady = 'content-ready';
/** @hidden */
export var dataReady = 'data-ready';
/** @hidden */
export var initSubComponent = 'init-groupingbar';
/** @hidden */
export var treeViewUpdate = 'tree-view-update';
/** @hidden */
export var pivotButtonUpdate = 'pivot-button-update';
/** @hidden */
export var initCalculatedField = 'init-calculatedfield';
/** @hidden */
export var click = 'click';
/** @hidden */
export var initToolbar = 'init-toolbar';
/** @hidden */
export var initPivotPager = 'init-pivotPager';
/** @hidden */
export var initFormatting = 'init-formatting';
/** @hidden */
export var initGrouping = 'init-grouping';
/**
 * Specifies action names of actionBegin events
 */
/** @hidden */
export var sortValue = 'Sort value';
/** @hidden */
export var drillUp = 'Drill up';
/** @hidden */
export var drillDown = 'Drill down';
/** @hidden */
export var addNewReport = 'Add new report';
/** @hidden */
export var saveCurrentReport = 'Save current report';
/** @hidden */
export var saveAsCurrentReport = 'Save as current report';
/** @hidden */
export var renameCurrentReport = 'Rename current report';
/** @hidden */
export var removeCurrentReport = 'Remove current report';
/** @hidden */
export var loadReports = 'Load report';
/** @hidden */
export var openConditionalFormatting = 'Open conditional formatting dialog';
/** @hidden */
export var openNumberFormatting = 'Open number formatting dialog';
/** @hidden */
export var MdxQuery = 'MdxQuery';
/** @hidden */
export var showFieldList = 'Open field list';
/** @hidden */
export var tableView = 'Show table view';
/** @hidden */
export var chartView = 'Show chart view';
/** @hidden */
export var multipleAxis = 'Multiple Axis';
/** @hidden */
export var showLegend = 'Show legend';
/** @hidden */
export var pdfExport = 'PDF export';
/** @hidden */
export var pngExport = 'PNG export';
/** @hidden */
export var excelExport = 'Excel export';
/** @hidden */
export var csvExport = 'CSV export';
/** @hidden */
export var jpegExport = 'JPEG export';
/** @hidden */
export var svgExport = 'SVG export';
/** @hidden */
export var hideSubTotals = 'Hide sub-totals';
/** @hidden */
export var subTotalsRow = 'Show row sub-totals';
/** @hidden */
export var subTotalsColumn = 'Show column sub-totals';
/** @hidden */
export var showSubTotals = 'Show sub-totals';
/** @hidden */
export var hideGrandTotals = 'Hide grand totals';
/** @hidden */
export var grandTotalsRow = 'Show row grand totals';
/** @hidden */
export var grandTotalsColumn = 'Show column grand totals';
/** @hidden */
export var showGrandTotals = 'Show grand totals';
/** @hidden */
export var numberFormattingMenu = 'Number Formatting menu';
/** @hidden */
export var conditionalFormattingMenu = 'Conditional Formatting menu';
/** @hidden */
export var reportChange = 'Report change';
/** @hidden */
export var sortFieldTree = 'Sort field tree';
/** @hidden */
export var editCalculatedField = 'Edit calculated field';
/** @hidden */
export var sortField = 'Sort field';
/** @hidden */
export var filterField = 'Filter field';
/** @hidden */
export var removeField = 'Remove field';
/** @hidden */
export var openCalculatedField = 'Open calculated field dialog';
/** @hidden */
export var editRecord = 'Edit record';
/** @hidden */
export var saveEditedRecords = 'Save edited records';
/** @hidden */
export var addNewRecord = 'Add new record';
/** @hidden */
export var removeRecord = 'Remove record';
/** @hidden */
export var aggregateField = 'Aggregate field';
/** @hidden */
export var contextMenuCalculatedField = 'CalculatedField Context menu';
/** @hidden */
export var windowResize = 'Window resize';
/** @hidden */
export var rowPageNavigation = 'Navigate row page';
/** @hidden */
export var columnPageNavigation = 'Navigate column page';
/**
 * Specifies action names of actionComplete events
 */
/** @hidden */
export var calculatedFieldApplied = 'Calculated field applied';
/** @hidden */
export var editedRecordsSaved = 'Edited records saved';
/** @hidden */
export var newRecordAdded = 'New record added';
/** @hidden */
export var recordRemoved = 'Record removed';
/** @hidden */
export var closeFieldlist = 'Field list closed';
/** @hidden */
export var fieldTreeSorted = 'Field tree sorted';
/** @hidden */
export var reportSaved = 'Report saved';
/** @hidden */
export var newReportAdded = 'New report added';
/** @hidden */
export var reportReSaved = 'Report re-saved';
/** @hidden */
export var reportRenamed = 'Report renamed';
/** @hidden */
export var reportRemoved = 'Report removed';
/** @hidden */
export var excelExported = 'Excel exported';
/** @hidden */
export var csvExported = 'CSV exported';
/** @hidden */
export var pdfExported = 'PDF exported';
/** @hidden */
export var pngExported = 'PNG exported';
/** @hidden */
export var jpegExported = 'JPEG exported';
/** @hidden */
export var svgExported = 'SVG exported';
/** @hidden */
export var conditionallyFormatted = 'Conditional formatting applied';
/** @hidden */
export var numberFormatted = 'Number formatting applied';
/** @hidden */
export var tableViewed = 'Table view shown';
/** @hidden */
export var chartViewed = 'Chart view shown';
/** @hidden */
export var subTotalsHidden = 'Sub-totals hidden';
/** @hidden */
export var subTotalsRowShown = 'Row sub-totals shown';
/** @hidden */
export var subTotalsColumnShown = 'Column sub-totals shown';
/** @hidden */
export var subTotalsShown = 'Sub-totals shown';
/** @hidden */
export var grandTotalsHidden = 'Grand totals hidden';
/** @hidden */
export var grandTotalsRowShown = 'Row grand totals shown';
/** @hidden */
export var grandTotalsColumnShown = 'Column grand totals shown';
/** @hidden */
export var grandTotalsShown = 'Grand totals shown';
/** @hidden */
export var valueSorted = 'Value sorted';
/** @hidden */
export var calculatedFieldEdited = 'Calculated field edited';
/** @hidden */
export var fieldSorted = 'Field sorted';
/** @hidden */
export var fieldFiltered = 'Field filtered';
/** @hidden */
export var fieldRemoved = 'Field removed';
/** @hidden */
export var fieldAggregated = 'Field aggregated';
/** @hidden */
export var recordEdited = 'Record edited';
/** @hidden */
export var reportChanged = 'Report changed';
/** @hidden */
export var windowResized = 'Window resized';
/** @hidden */
export var recordUpdated = 'Records updated';
/** @hidden */
export var drillThroughClosed = 'Drill-through closed';
/** @hidden */
export var verticalScrolled = 'Vertically scrolled';
/** @hidden */
export var horizontalScrolled = 'Horizontally scrolled';
/** @hidden */
export var rowPageNavigated = 'Row page navigated';
/** @hidden */
export var columnPageNavigated = 'Column page navigated';
/** @hidden */
export var actionDropped = 'Action dropped';
